import { $_app_server } from '@/_helpers'
import { checkResponse } from '@/_helpers'
export const goalsService = {
  getAllGoals,
  createGoals,
  createFormGoals,
  setAttachmentOne,
  afterAttachment,
  delAttachment,
  setSpeech,
  afterSpeech,
  delSpeech,
  changeActiveGoal,
  getLoadedPhoto,
  getLoadedSpeech
}

function getAllGoals() {
  return $_app_server.get(`/api-allgoals`).then(response => (checkResponse(response.data)))
}

function createFormGoals() {
  return $_app_server.post(`/api-createGoal`).then(response => (checkResponse(response.data)))
}

function createGoals(goalsObj) {
  var data = new FormData()

  data.append("title", goalsObj.title)
  if(goalsObj.active == "true" || goalsObj.active == "false") data.append("active", goalsObj.active == "false" ? 0 : 1)
  else data.append("active", goalsObj.active)
  if(goalsObj.status == "completed" || goalsObj.status == "in progress") data.append("status", goalsObj.active == "completed" ? 0 : 1)
  else data.append("status", goalsObj.status)
  data.append("obj", goalsObj.uuid)
  data.append("full_amount", goalsObj.full_amount)
  data.append("accumulated_amount", "0")
  data.append("completed_date", goalsObj.completed_date)
  data.append("user_phone", goalsObj.user_phone)

  return $_app_server.post(`/api-createGoal?state=1`, data).then(response => (checkResponse(response.data)))
}

function setAttachmentOne(obj) {
  return $_app_server.post(`/api-addPhotoGoal?object_id=${obj.goalsUuid}&fileapi${Date.parse(new Date)}=`, obj.photo, {
    headers: {'Content-Type': 'multipart/form-data'}
  }).then(response => (checkResponse(response.data)))
}

function afterAttachment(obj, state) {
  let data = new FormData()
  data.append('state', state)
  return $_app_server.post(`/api-addPhotoGoal?object_id=${obj.goalsUuid}&obj=${obj.goalsUuid}`, data).then(response => (checkResponse(response.data)))
}

function delAttachment(obj, state) {
  let data = new FormData()
  data.append('state', state)
  return $_app_server.get(`/api-delPhotoGoal?obj=${obj.goalsUuid}&state=${state}`).then(response => (checkResponse(response.data)))
}

function setSpeech(obj) {
  return $_app_server.post(`/api-addAudioGoal?object_id=${obj.goalsUuid}&fileapi${Date.parse(new Date)}=`, obj.audio, {
    headers: {'Content-Type': 'multipart/form-data'}
  }).then(response => (checkResponse(response.data)))
}

function afterSpeech(obj, state) {
  let data = new FormData()
  data.append('state', state)
  return $_app_server.post(`/api-addAudioGoal?object_id=${obj.goalsUuid}&obj=${obj.goalsUuid}`, data).then(response => (checkResponse(response.data)))
}

function delSpeech(obj, state) {
  let data = new FormData()
  data.append('state', state)
  return $_app_server.get(`/api-delAudioGoal?obj=${obj.goalsUuid}&state=${state}`).then(response => (checkResponse(response.data)))
}

function changeActiveGoal(obj) {
  return $_app_server.get(`/api-changeActiveGoal?activeUuid=${obj.activeUuid}&unactiveUuid=${obj.unactiveUuid}`).then(response => (checkResponse(response.data)))
}

function getLoadedPhoto(goalUuid) {
  return $_app_server.get(`/api-getGoalPhoto?obj=${goalUuid}`, {responseType: "blob"}).then(response => (checkResponse(response)))
}

function getLoadedSpeech(goalUuid) {
  return $_app_server.get(`/api-getGoalAudio?obj=${goalUuid}`, {responseType: "blob"}).then(response => (checkResponse(response)))
}